var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typing-bubble"},[_c('div',_vm._l((3),function(i){return _c('span',{key:i,class:{ active: _vm.active === i }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }